import getLocale from "@/utils/get-locale";

function getNotifications() {
  const locale = getLocale();
  if (locale === "ru-RU") return notificationsRU;
  return notificationsEN;
}

const notificationsRU = {
  success: {
    addToCart: {
      status: "success",
      message: "Артикул добавлен в корзину"
    },
    addItemsToCart: {
      status: "success",
      message: "Артикулы добавлены в корзину"
    },
    hiddenOrder: {
      status: "success",
      message: "Добавлен в архив"
    },
    showHiddenOrder: {
      status: "success",
      message: "Достан из архива"
    },
    addToWishlist: {
      status: "success",
      message: "Артикул добавлен в избранное"
    },
    addItemsToWishlist: {
      status: "success",
      message: "Артикулы добавлены в избранное"
    },
    wishlistAdded: {
      status: "success",
      message: "Создан новый список избранного"
    },
    wishlistRemoved: {
      status: "success",
      message: "Список избранного удалён"
    },
    wishlistUpdated: {
      status: "success",
      message: "Список избранного обновлён"
    },
    articleRemoved: {
      status: "success",
      message: "Артикул удалён"
    },
    wearResistantProjectCreated: {
      status: "success",
      message: "Проект отправлен"
    },
    newCompanySend: {
      status: "success",
      message: "Заявка на добавление компании принята"
    },
    requestSend: {
      status: "success",
      message: "Запрос отправлен"
    },
    newsletter: {
      status: "success",
      message: "Подписка оформлена"
    },
    bugreport: {
      status: "success",
      message: "Сообщение об ошибке отправлено"
    },
    fileUpload: {
      status: "success",
      message: "Файл(ы) загружен(ы)"
    },
    addNewProductionSite: {
      status: "success",
      message: "Производственная площадка добавлена"
    },
    addNewInstalledBase: {
      status: "success",
      message: "Инсталированная база добавлена"
    },
    updateInstalledBase: {
      status: "success",
      message: "Инсталированная база обновлена"
    },
    addNewModel: {
      status: "success",
      message: "Заявка на добавление новой модели принята"
    },
    addEquipmentToCart: {
      status: "success",
      message: "Товар добавлен в корзину"
    },
    inquiryClosed: {
      status: "success",
      message: "Inquiry was closed"
    }
  },
  error: {
    base: {
      status: "error",
      message: "Произошла ошибка"
    },
    getData: {
      status: "error",
      message: "Произошла ошибка во время получения данных"
    },
    requiredFields: {
      status: "error",
      message: "Заполните обязательные поля"
    },
    setManager: {
      status: "error",
      message: "Произошла ошибка при выборе менеджера"
    },
    setCompany: {
      status: "error",
      message: "Произошла ошибка при выборе компании"
    },
    companyNotSelected: {
      status: "error",
      message: "Компания не выбрана"
    }
  }
};

const notificationsEN = {
  success: {
    addToCart: {
      status: "success",
      message: "Article has been added to the cart"
    },
    addItemsToCart: {
      status: "success",
      message: "Articles have been added to the cart"
    },
    addToWishlist: {
      status: "success",
      message: "Article has been added to the wishlist"
    },
    addItemsToWishlist: {
      status: "success",
      message: "Articles have been added to the wishlist"
    },
    wishlistAdded: {
      status: "success",
      message: "New wishlist has been created"
    },
    wishlistRemoved: {
      status: "success",
      message: "Wishlist has been removed"
    },
    wishlistUpdated: {
      status: "success",
      message: "Wishlist has been updated"
    },
    articleRemoved: {
      status: "success",
      message: "Article has been removed"
    },
    wearResistantProjectCreated: {
      status: "success",
      message: "Project has been sent"
    },
    newCompanySend: {
      status: "success",
      message: "Request for adding the company has been accepted"
    },
    requestSend: {
      status: "success",
      message: "Request has been sent"
    },
    newsletter: {
      status: "success",
      message: "Subscribed"
    },
    bugreport: {
      status: "success",
      message: "Message has been sent"
    },
    fileUpload: {
      status: "success",
      message: "File(s) uploaded successfully"
    },
    addNewProductionSite: {
      status: "success",
      message: "Production site has been added"
    },
    addNewInstalledBase: {
      status: "success",
      message: "Installed base has been added"
    },
    updateInstalledBase: {
      status: "success",
      message: "Installed base has been updated"
    },
    addNewModel: {
      status: "success",
      message: "Request for adding the model has been accepted"
    }
  },
  error: {
    base: {
      status: "error",
      message: "Something went wrong"
    },
    getData: {
      status: "error",
      message: "Error has occurred while retrieving the data"
    },
    requiredFields: {
      status: "error",
      message: "Fill in mandatory fields"
    },
    setManager: {
      status: "error",
      message: "Error has occurred while choosing the manager"
    },
    setCompany: {
      status: "error",
      message: "Error has occurred while choosing the company"
    },
    companyNotSelected: {
      status: "error",
      message: "No company has been selected"
    }
  }
};

export default getNotifications();
